// extracted by mini-css-extract-plugin
export default {"container":"marker-module__container__YN31W","icon":"marker-module__icon__HwY90"};